import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import SEO from '../common/SEO';

const NotFound = () => {
  // Structured data for the 404 page
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': 'Page Not Found - QualityAIvoice',
    'description': 'The page you are looking for does not exist. Return to the QualityAIvoice homepage for AI voice generation and text-to-speech services.'
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-dark-900">
      <SEO 
        title="Page Not Found | QualityAIvoice"
        description="The page you are looking for does not exist. Return to the QualityAIvoice homepage for AI voice generation and text-to-speech services."
        keywords="AI voice generator, text to speech, AI voices, voice synthesis"
        canonicalUrl="https://qualityaivoice.com/404"
        structuredData={structuredData}
        noindex={true}
      />
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <h2 className="mt-4 text-3xl font-semibold text-gray-900 dark:text-white">Page Not Found</h2>
          <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
            The page you are looking for doesn't exist or has been moved.
          </p>
          
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/" 
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              <Home className="mr-2 h-5 w-5" />
              Back to Home
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 dark:border-dark-700 text-base font-medium rounded-md shadow-sm text-gray-700 dark:text-white bg-white dark:bg-dark-800 hover:bg-gray-50 dark:hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Go Back
            </button>
          </div>
          
          <div className="mt-12">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              Looking for something specific?
            </h3>
            <div className="mt-4 grid grid-cols-2 gap-4">
              <Link 
                to="/blog" 
                className="p-4 border border-gray-200 dark:border-dark-700 rounded-lg hover:bg-gray-50 dark:hover:bg-dark-800 transition-colors"
              >
                <p className="font-medium text-gray-900 dark:text-white">AI Voice Blog</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Best text to speech guides & reviews</p>
              </Link>
              <Link 
                to="/about" 
                className="p-4 border border-gray-200 dark:border-dark-700 rounded-lg hover:bg-gray-50 dark:hover:bg-dark-800 transition-colors"
              >
                <p className="font-medium text-gray-900 dark:text-white">About QualityAIvoice</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">Learn about our AI voice technology</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
